import * as Yup from 'yup';

export const CreateApiKeyValidationSchema = Yup.object().shape({
	name: Yup.string().trim().max(64).required(),
});
